"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingOrdersMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class BookingOrdersMapper {
    toDomain(result) {
        var _a;
        const hasError = !!lodash_1.default.get(result, "error");
        const isOrdersLoading = lodash_1.default.get(result, "loading");
        /* istanbul ignore next */
        const orders = (_a = lodash_1.default.get(result, "data.active.edges")) === null || _a === void 0 ? void 0 : _a.map((o) => (Object.assign(Object.assign({}, o === null || o === void 0 ? void 0 : o.node), { __typename: "BookingOrder" })));
        return {
            hasError,
            isOrdersLoading,
            orders,
        };
    }
}
exports.BookingOrdersMapper = BookingOrdersMapper;
